module.exports = __webpack_public_path__ + "img/info-fill-blue.e3fe406c.svg";